module.exports = __webpack_public_path__ + "img/banner-natal.bc1e9ce2.jpg";